import React from 'react';
import RescueMobileCard from '../../pages/Rescue/RescueMobileCard';
import ReleaseRescueButtons from './ReleaseRescueButtons';

const UpcomingRescue = ({
  rescue,
  noShadow = false,
  currentSlide = 0,
  maxSlides = 0,
  isRescueSlider = false,
  handleSliderNext = () => {},
  handleSliderPrev = () => {},
  isReceiverView = false,
  isDonorView = false,
  claimer = {},
  rescueSliderRef = {},
}) => (
  <RescueMobileCard
    rescue={rescue}
    isCancelled={rescue.cancelled_by_id !== null}
    noShadow={noShadow}
    currentSlide={currentSlide}
    isRescueSlider={isRescueSlider}
    handleSliderNext={handleSliderNext}
    handleSliderPrev={handleSliderPrev}
    maxSlides={maxSlides}
    claimer={claimer}
    isReceiverView={isReceiverView}
    isDonorView={isDonorView}
    hideDonorLink={isReceiverView || isDonorView}
    hideExpandPanel={isReceiverView || isDonorView}
    rescueSliderRef={rescueSliderRef}
  >
    <ReleaseRescueButtons rescue={rescue} />
  </RescueMobileCard>
);

export default UpcomingRescue;
